import { ext } from '@/utils/linkTarget'
import MahimaIcon from '@/components/atoms/mahimaIcon'
import { PortableText } from 'next-sanity'
import editorRule from '@/components/atoms/editorRule'
import Link from 'next/link'

const EXPLORE = [
  { name: 'Padel Courts',   href: '/padel-ubud'  },
  { name: 'Tennis Courts',  href: '/tennis-ubud' },
  { name: 'Gym & Wellness', href: '/gym-ubud'    },
  { name: 'Restaurant',     href: '/restaurant'  },
  { name: 'Tennis Camp',    href: '/tennis-camp' },
  { name: 'Padel Camp',     href: '/padel-camp'  },
]

const MAHIMA = [
  { name: 'Pricing',     href: '/pricing'   },
  { name: 'Book & Join', href: '/book-join' },
  { name: 'Schedule',    href: '/schedule-and-classes' },
  { name: 'Retreat',     href: '/retreat'   },
  { name: 'About',       href: '/about'     },
  { name: 'Contact',     href: '/contact'   },
]

const label = 'font-chivoMono text-dune/70 text-[11px] uppercase tracking-widest mb-6'
const item = 'w-fit font-chivoMono text-bodyMobile md:text-bodyDesktop text-background/80 hover:text-background transition-colors duration-200'

function Column({ title, children }) {
  return (
    <div>
      <p className={label}>{title}</p>
      <div className="flex flex-col gap-3">{children}</div>
    </div>
  )
}

const Footer = ({ footerAPI }) => {
  const { contact } = footerAPI

  return (
    <footer className="relative w-full bg-forest px-smallMobile md:px-mediumDesktop pt-[80px] lg:pt-[110px] pb-10">
      <div className="max-w-container mx-auto">

        {/* Two main actions as large link cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 lg:gap-4 pb-12 lg:pb-16 border-b border-background/20">
          <Link href="/book-join"
            className="group flex items-center justify-between gap-6 p-7 lg:p-9 border border-background/25 text-background hover:border-background/60 transition-colors duration-300">
            <span className="font-ttDrugsTrial text-[26px] lg:text-[32px] leading-none">Book Facilities</span>
            <span aria-hidden="true" className="text-[24px] transition-transform duration-300 group-hover:translate-x-1">→</span>
          </Link>
          <a href={contact.whatsapp.link} {...ext(contact.whatsapp.link)}
            className="group flex items-center justify-between gap-6 p-7 lg:p-9 bg-dune text-forest hover:bg-background transition-colors duration-300">
            <span className="font-ttDrugsTrial text-[26px] lg:text-[32px] leading-none">WhatsApp Us</span>
            <span aria-hidden="true" className="text-[24px] transition-transform duration-300 group-hover:translate-x-1">→</span>
          </a>
        </div>

        {/* Link columns */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-14 py-12 lg:py-16">
          <Column title="Explore">
            {EXPLORE.map((l) => <Link key={l.href} href={l.href} className={item}>{l.name}</Link>)}
          </Column>

          <Column title="Mahima">
            {MAHIMA.map((l) => <Link key={l.href} href={l.href} className={item}>{l.name}</Link>)}
          </Column>

          <Column title="Contact">
            <a href={contact.whatsapp.link} {...ext(contact.whatsapp.link)} className={item}>
              {contact.whatsapp.phoneNumber}
            </a>
            <a href={`mailto:${contact.email}`} className={item}>{contact.email}</a>
            <a href={contact.instagram.link} {...ext(contact.instagram.link)} className={item}>
              {contact.instagram.name}
            </a>
          </Column>

          <Column title="Visit">
            <p className="font-chivoMono text-bodyMobile md:text-bodyDesktop text-background/80">{footerAPI.address}</p>
            <div className="font-chivoMono text-bodyMobile md:text-bodyDesktop text-background/80">
              <PortableText value={footerAPI.operationalHours} components={editorRule()} />
            </div>
            <a
              href={footerAPI.mapLink}
              {...ext(footerAPI.mapLink)}
              className="w-fit font-chivoMono text-background text-[12px] uppercase tracking-widest underline underline-offset-4 hover:text-background/70 transition-colors duration-200 mt-2"
            >
              Open in Google Maps
            </a>
          </Column>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background/20 pt-8 flex flex-col md:flex-row md:items-end md:justify-between gap-6 font-chivoMono text-[12px] text-background/50">
          <div className="w-[120px] [&_svg]:w-full [&_svg]:h-auto">
            <MahimaIcon />
          </div>
          <div className="flex flex-col md:items-end gap-1">
            <p>Padel, tennis, gym &amp; recovery in Sayan, Ubud, Bali</p>
            <p>© {new Date().getFullYear()} Mahima. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
